import { useTranslations } from '@vocab/react';
import { Box, Stack } from 'braid-design-system';

import type { Market } from '../../../types';
import { MarketSelector } from '../../MarketSelector/MarketSelector';
import { FilterAccordion } from '../FilterAccordion/FilterAccordion';
import { SearchFilter } from '../SearchFilter/SearchFilter';
import type { Suggestion } from '../types';

import translations from './.vocab';

import { inputParent } from './LocationFilter.css';

interface Props {
  expanded: boolean;
  selectedItems: Suggestion[];
  suggestions: Suggestion[];
  onChange: (newSelectedItems: Suggestion[]) => void;
  onDebouncedSearchTextChange: (newSearchText: string) => void;
  onSearchTextChange?: (newSearchText: string) => void;
  onExpandedToggle: (expanded: boolean) => void;
  marketState: {
    value: Market;
    onChange: (marketSelected: Market) => void;
  };
}

export const LocationFilter = ({
  expanded,
  selectedItems,
  suggestions,
  onChange,
  onDebouncedSearchTextChange,
  onSearchTextChange,
  onExpandedToggle,
  marketState: { value: market, onChange: onMarketChange },
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <FilterAccordion
      id="location-accordion-filter"
      expanded={expanded}
      label={t('LOCATION')}
      selectedItems={selectedItems}
      onToggle={onExpandedToggle}
    >
      <Stack space="small">
        <Box className={inputParent}>
          <MarketSelector
            marketSelected={market}
            onMarketChange={onMarketChange}
            size="small"
          />
        </Box>
        <SearchFilter
          id="location-filter"
          label=""
          placeholder={t('LOCATION_FILTER_PLACEHOLDER')}
          suggestions={suggestions}
          selectedItems={selectedItems}
          onDebouncedSearchTextChange={onDebouncedSearchTextChange}
          onSearchTextChange={onSearchTextChange}
          onChange={onChange}
        />
      </Stack>
    </FilterAccordion>
  );
};
